import { Expose, Type } from 'class-transformer';
import { BaseEntity } from './base.entity';
import { InstallationImageEntity } from './installation-image.entity';

export class InstallationImageListEntity extends BaseEntity {
  @Expose()
  @Type(() => InstallationImageEntity)
  public images: InstallationImageEntity[];
}
